export default {
	activeBackground: "lightgray", //"#00aeef"
}